import {
  typography,
  colors,
  size,
  mediaQueries,
  PrimaryButtonStyle,
  SecondaryButtonStyle,
  HeroButtonStyle,
  TertiaryButtonStyle,
} from '@everlywell/leaves';
import React from 'react';
import styled, { css } from 'styled-components';

const bodyCopyStyles = css`
  font-size: 16px;
  line-height: 1.88;
  letter-spacing: 0.3px;

  ${mediaQueries.forTabletHorizontalUp} {
    font-size: 18px;
    line-height: 1.78;
    letter-spacing: 0.7px;
  }
`;

const Body = styled.div`
  margin-top: 14px;
  color: ${colors.gray4};
  font-weight: ${typography.weight.light};

  h1,
  h2,
  h3 {
    font-family: ${typography.type.ppAgrandir};
    color: ${colors.gray4};
    font-weight: ${typography.weight.regular};
    font-size: 25.6px;
    line-height: 1.56;
    letter-spacing: normal;
    margin: 0 0 1rem;
  }

  h1 {
    font-size: 32.4px;
  }

  h2 {
    font-size: 25.6px;
    margin-top: 20px;
  }

  h3 {
    font-size: 1em;
  }

  p {
    margin: 0 0 16px;
    ${bodyCopyStyles};
    font-weight: ${typography.weight.light};

    strong {
      font-weight: ${typography.weight.bold};
    }

    small {
      font-size: 14px;
    }

    .gatsby-resp-image-wrapper {
      position: relative;
      left: 50%;
      margin-left: -50vw !important;
      margin-right: -50vw !important;
      margin-top: 40px;
      max-width: 100vw !important;
      right: 50%;
      width: 100vw;

      ${mediaQueries.forTabletVerticalUp} {
        left: unset;
        margin-left: unset !important;
        margin-right: unset !important;
        max-width: unset !important;
        right: unset;
        width: unset;
      }
    }
  }

  a {
    transition: 0.2s;
    text-decoration: none;
    color: ${colors.teal4};

    &:hover,
    &:focus {
      color: ${colors.teal4};
      text-decoration: underline;
    }

    &:active {
      color: ${colors.teal4};
    }
  }

  del {
    text-decoration: line-through;
  }

  strong {
    font-weight: 600;
  }

  em {
    display: block;
    text-align: center;
    margin-top: 12px;
    ${bodyCopyStyles};
    font-weight: ${typography.weight.light};
  }

  ul,
  ol {
    margin: 0 0 1em;
  }

  ul {
    list-style: none;
    margin-left: 32px;

    li {
      margin-bottom: 16px;
      font-weight: ${typography.weight.light};
      color: ${colors.gray4};
      font-size: 18px;
      line-height: 32px;
      letter-spacing: 0.7px;

      &::before {
        content: '\\2022';
        color: ${colors.gray4};
        font-weight: ${typography.weight.xbold};
        display: inline-block;
        width: 1em;
        margin-left: -1em;
      }

      &:last-child {
        margin: 0;
      }

      > p {
        display: inline;
      }
    }
  }

  ol {
    margin-left: 32px;

    li {
      list-style: decimal;
      list-style-position: inside;
      margin-bottom: 16px;

      &:last-child {
        margin: 0;
      }

      ${bodyCopyStyles};
      font-weight: ${typography.weight.light};
    }
  }

  hr {
    border: none;
    border-top: 1px solid ${colors.gray4};
    margin-top: 23px;
    margin-bottom: 20px;
  }

  blockquote {
    ${bodyCopyStyles};
    font-weight: ${typography.weight.regular};
    font-style: italic;
    border-left: 4px solid ${colors.gray4};
    padding: 0 0 0 0.5em;
  }

  pre {
    ${bodyCopyStyles};
    font-weight: ${typography.weight.light};
    margin: 0 0 2em;
    border-radius: 2px;
    background: ${colors.gray1} !important;

    span {
      background: inherit !important;
    }
  }

  span {
    font-weight: ${typography.weight.light};
  }

  /* Classes to accomodate CTA's within a blog post body */
  .center {
    display: flex;
    justify-content: center;
    padding: ${size.md}px 0;
  }

  .left {
    display: flex;
    justify-content: flex-start;
    padding: ${size.md}px 0;
  }

  .right {
    display: flex;
    justify-content: flex-end;
    padding: ${size.md}px 0;
  }

  a.button {
    ${PrimaryButtonStyle};

    &.secondary {
      ${SecondaryButtonStyle}
    }

    &.tertiary {
      ${TertiaryButtonStyle}
    }

    &.hero {
      ${HeroButtonStyle}
    }
  }
`;

const PageBody = (props) => (
  <Body
    dangerouslySetInnerHTML={{ __html: props.body.childMarkdownRemark.html }}
  />
);

export default PageBody;
